import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import SpatialRelations from "../ui/spatial_relations/SpatialRelations";
import SpatialRelationsDetails from "../ui/spatial_relations/SpatialRelationDetails";
import SpatialRelationsList from "../ui/spatial_relations/SpatialRelationsList";
import SpatialRelationsAddEdit from "../ui/spatial_relations/SpatialRelationsAddEdit";

const SpatialRelationsRoutes = (
  <Route
    path={AppSections.SPATIAL_RELATIONS}
    element={
      <ProtectedRoute>
        <SpatialRelations/>
      </ProtectedRoute>
    }
  >
    {/* <Route path="create" element={<SpatialRelationsAddEdit />} /> */}
    <Route path=":id/view" element={<SpatialRelationsDetails />} />


    {/* <Route path="/pilots/" element={<PilotsList />} />
    <Route path="create" element={<PilotAddEdit />} />
    <Route path=":id/view" element={<PilotDetails />} />
    <Route path=":id/edit" element={<PilotAddEdit />} /> */}
  </Route>
);

export default SpatialRelationsRoutes;
